import { Component, OnInit } from '@angular/core';
import { CstemapiService } from '../cstemapi.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-publication',
  templateUrl: './publication.component.html',
  styleUrls: ['./publication.component.scss']
})
export class PublicationComponent implements OnInit {
  publications: any = [];
  manuals: any = [];

  constructor(public cstemapi: CstemapiService, private myRoute: Router, private auth: AuthService) {
    this.publications = [
      {
        img: 'publication/p1.png',
        title: 'CSTEP’s Solar Techno-Economic Model for Photovoltaics (CSTEM PV): Solar and Financial Models',
        contributor: 'Harshid Sridhar',
        year: 'Sep 2019',
        link: 'https://www.cstep.in/drupal/sites/default/files/2019-09/CSTEP_RR_CSTEM_PV_P1_0.pdf',
        description: 'This report aims to serve as a reference document for those interested in obtaining an in-depth understanding of the CSTEM PV tool. It details the basis, considerations, and applications of the solar and financial models supporting the tool.'
      },
      {
        img: 'publication/p2.png',
        title: '  Rectangular Spiral Inspired Approach for Estimating Area of Solar Photovoltaic Plants in India',
        contributor: 'Harshid Sridhar, Thirumalai N.C.',
        year: 'Sep 2019',
        link: 'https://www.cstep.in/drupal/sites/default/files/2020-04/CSTEP_RR_Spiral_v3.pdf',
        description: 'This work proposes a method which can provide a rational area estimate of a PV plant factoring sizing considerations from electrical, maintenance, and shading aspects. The idea for the plant design is inspired by the number pattern illustrated in the Ulam spiral. Further, this report provides insights on land area requirements across the latitudinal spread for India. It also provides an estimate of the solar power potential for ground-mounted utility scale plants in India.'
      },
      {
        img: 'publication/p3.png',
        title: 'Performance Comparison of Solar Photovoltaic Models for Plant Siting in India',
        contributor: 'Dr Kelly Klima, Harshid Sridhar, Vaishalee Dash, Dr Mridula Dixit Bharadwaj, Dr Parveen Kumar, Prof. Jay Apt',
        year: 'Jan 2019',
        link: 'https://www.cstep.in/drupal/sites/default/files/2019-02/CSTEP_WS_Performance_Comparison_Solar_PV_Models_India_Jan2019.pdf',
        description: 'This report examines the performance of four models of annual solar photovoltaic production that are appropriate for site selection against actual generation data from utility-scale plants in Gujarat (India). It identifies the best model to predict the output of the plant. Also, it recommends a model in the absence of spatially and temporally coincident solar resource and plant generation data.  '
      },
      {
        img: 'publication/p4.jpg',
        title: 'Effect of Module Reliability on Techno-Economics of a Utility Scale Solar Photovoltaic Plant in India',
        contributor: 'Harshid Sridhar, Thirumalai N.C.',
        year: 'Nov 2018',
        link: 'https://www.cstep.in/drupal/sites/default/files/2019-01/CSTEP_RR_PV_Reliability_Nov2018.pdf',
        description: 'This report examines the following three aspects: What is the effect of standard module degradation on plant techno-economics, for locations spread across different climate zones? What is the permissible rate of annual module degradation such that the plant remains financially viable? What is the effect of the cleaning cycle on plant techno-economics (via soiling losses)? '
      },
      {
        img: 'publication/p5.jpg',
        title: 'Techno-Economic Analysis of Stand-alone Solar PV and Battery based Micro-grids in Karnataka',
        contributor: 'Vaishalee Dash, Badri S. Rao, Harshid Sridhar, Dr Mridula Dixit Bharadwaj',
        year: 'Jun 2018',
        link: 'https://www.cstep.in/drupal/sites/default/files/2019-02/CSTEP_report_Techno_Economic_Analysis_of_Stand_alone_Solar_PV_battery_based_micro_grids_in_Karnataka.pdf',
        description: 'This report details the case analysis of Solar PV Micro Grids (SPVMG) for select sites in Karnataka. It proposes a detailed methodology for sizing the battery system considering the pattern of electricity demand. It presents a case illustrating the trade-off between cost and reliability of the SPVMG systems. '
      },
      {
        img: 'publication/p6.jpg',
        title: 'Techno-Economic Feasibility of Grid-Tied Solar Mini-Grids',
        contributor: 'Vaishalee Dash, Aklavya Sharan, Badri Rao, Mridula Bharadwaj',
        year: 'Sep 2017',
        link: 'https://www.cstep.in/drupal/sites/default/files/2018-12/CSTEP_PB_Techno_economic_feasibility_of_grid_tied_solar_mini_grids_Sep2017.pdf',
        description: 'The cumulative number of households waiting for power supply is close to 4 crore. Majority of electrified villages have huge demand-supply gap and access to power is unreliable or of low quality. In many rural areas, electricity is barely available for economic use and development. Grid-tied renewable powered mini-grids can help improve reliability and augment supply to the central grid effectively. '
      }
    ]

    this.manuals = [
      {
        img: '../../../src/assets/newVFiles/CSTEM_PV_Manual_v1.2_db_140520-1.jpg',
        title: 'CSTEP’s Solar Techno-Economic Model for Photovoltaics (CSTEM PV) : User Guide',
        contributor: 'Harshid Sridhar, Dr Vinay Kandagal',
        year: 'May 2020',
        // link: '../../../../src/assets/newVFiles/CSTEM_PV_Manual_v1.2_db_140520.pdf',
        link: '../../../../src/assets/newVFiles/CSTEM_PV_Manual_v1.2_db_140520.pdf',
        description: 'This document serves as a user guide/manual for building cases in the CSTEM PV tool.'
      }
    ];

    // this.publications.sort((a, b) => a.year < b.year ? -1 : a.year > b.year ? 1 : 0)
  }

  ngOnInit() {
  }

}
